import { css } from "styled-components";

export const AvailableKey = (selectable: boolean) => css`
     background-color: #fff;
     color: var(--main-grey-color);
     ${selectable &&
        `&:hover {
            transition: all 0.2s ease 0s;
            background: #ffd875;
        }`};
`;
export const UnavailableKey = css`
    background-color: var(--main-teal-color);
    color: #fff;
`;
export const SelectedKey = css`
    background-color: var(--main-orange-color);
`;
export const CollectionKey  = (available: boolean) => css`
    color: var(--main-grey-color);
    background-image: linear-gradient(to top left, ${available ? "var(--main-orange-color)" : "var(--main-teal-color)"} 50%, #ffff 50%);
`;
export const CollectionReturnKey = css`
    color: var(--main-grey-color);
    background-image: linear-gradient(to top left, var(--main-orange-color) 50%, var(--main-teal-color) 50%);
`;
export const ReturnCollectionKey = css`
    color: var(--main-grey-color);
    background-image: linear-gradient(to top left, var(--main-teal-color) 50%, var(--main-orange-color) 50%);
`;
export const ReturnKey  = (available: boolean) => css`
    color: var(--main-grey-color);
    background-image: linear-gradient(to bottom right, ${available ? "var(--main-orange-color)" : "var(--main-teal-color)"} 50%, #ffff 50%);
`;
export const BankHolidayKey = css`
    color: #fff;
    background-color: #cccccc;
`;